import { render, staticRenderFns } from "./ApplicantVehicle.vue?vue&type=template&id=67ee207e&scoped=true&"
import script from "./ApplicantVehicle.vue?vue&type=script&lang=js&"
export * from "./ApplicantVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee207e",
  null
  
)

export default component.exports